import {AbstractRepository} from "../repository";
import moment from "moment";

export interface ChatRoomInfoMember {
    sub: string
    name: string
    role: string
    employee_picture_url: string|null
    explicit: boolean
}
export interface ChatRoomInfo {
    id: string
    type: "network"|"team"|"message"|"group"
    concerns: {[key: string]: string|number}
    team_id: string|null
    name: string|null
    description: string|null
    members: ChatRoomInfoMember[]
    purged_at: Date|null
}
export interface ChatRoomMetadata {
  id: string
  is_favorite: boolean
  is_muted: boolean
  last_opened: string
  chat_read_progress?: {[key: string]: string}
}

export default class ChatRepository extends AbstractRepository {
    /**
     * List all teams in the system
     */
    public all(): Promise<Array<ChatRoomInfo>> {
        return this.request<{data: {[id: number]: ChatRoomInfo}}>('GET', 'my_chats')
            .then(this.unpackDataCollectionResponse)
          .then(items => {
            return items.map(room => {
              return {
                ...room,
                purged_at: room.purged_at ? new Date(room.purged_at) : null,
              }
            })
          })
    }

    public add(type: "team"|"message"|"group", members: number[], name?: string): Promise<Array<ChatRoomInfo>> {
        if (type === 'group' && name === undefined) {
            throw new Error('Name of chat must be defined when adding group')
        }
        return this.request<{data: {[id: number]: ChatRoomInfo}}>('POST', 'chat', {
            type: type,
            concerns: members,
            name: name ?? null,
        }).then(this.unpackDataCollectionResponse)
    }

    public async getMetadata(): Promise<Array<ChatRoomMetadata>> {
      return this.request<{data: {[id: number]: ChatRoomMetadata}}>('GET', 'chat_metadata')
        .then(this.unpackDataCollectionResponse)
    }
    public async updateMetadata(id: string, fields: Partial<Omit<ChatRoomMetadata, "id">>): Promise<ChatRoomMetadata> {
      const json = await this.request<{data: ChatRoomMetadata}>('POST', `chat_metadata/${id}`, {...fields})
      return json.data
    }
}
